<div class="code-input-component-root">
  <button class="close-button"
          *ngIf="hasCloseButton"
          mat-button
          (click)="emitClick()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-form-field class="form-input-component-root"
                  appearance="standard"
                  [ngClass]="{points}">
    <input *ngIf="!points"
           class="dotted"
           #inputField
           matInput
           [formControl]="control"
           [readonly]="readonly"
           autocomplete="off"
           [maxLength]="maxLength">
    <input *ngIf="points"
           class="dotted"
           #inputField
           matInput
           [formControl]="control"
           [readonly]="readonly"
           [maxLength]="maxLength"
           autocomplete="off"
           [ngClass]="{points}"
           mask="AAAA AAAA AAAA">
    <mat-error [ngClass]="{points}">{{errorMessage}}</mat-error>
    <span *ngIf="subscript" class="validated-point" [ngClass]="{points}">{{subscript}}</span>
    <mat-hint *ngIf="hasHint()">{{hint}}</mat-hint>
  </mat-form-field>
</div>
